var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.50398 8.5L11.884 11.9H9.84398L8.48398 9.9569L7.12398 11.9H5.08398L7.46398 8.5L5.08398 5.1H7.12398L8.48398 7.0431L9.84398 5.1H11.034V1.7H2.53398V15.3H14.434V5.1H11.884L9.50398 8.5ZM0.833984 0.8432C0.833984 0.3774 1.21393 0 1.68313 0H11.884L16.134 4.25V16.1441C16.1348 16.2557 16.1136 16.3664 16.0716 16.4698C16.0296 16.5732 15.9676 16.6674 15.8892 16.7468C15.8109 16.8263 15.7176 16.8896 15.6148 16.933C15.5119 16.9765 15.4016 16.9992 15.2899 17H1.67803C1.45481 16.9984 1.24115 16.9091 1.08322 16.7514C0.92529 16.5936 0.835765 16.38 0.833984 16.1568V0.8432Z",
    fill: "#03053D",
    fillOpacity: 0.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.354b512c7d4bd1d10a60ac08ea611f01.svg";
export { ForwardRef as ReactComponent };